import {
	GET_USER_ADMIN_INFO,
	GET_ROLE_ADMIN_INFO
} from './actions';
import { UserInfo, UserRole } from '../../Login/common/defaults';

interface IAdministrationState {
	lastAddedUser: any;
	users: UserInfo[];
	userRoles: UserRole[];
	roles: any[];
	permissions: any[];
}

const initialAdminState = {
	lastAddedUser: '',
	users: [],
	userRoles: [],
	roles: [],
	permissions: []
};

export default (state: IAdministrationState = initialAdminState, action: any) => {
	let _state = { ...state };
	switch (action.type) {
		case GET_USER_ADMIN_INFO:
			_state.users = [ ...action.value.users ];
			_state.roles = [ ...action.value.roles ];
			_state.permissions = [ ...action.value.permissions ];
			return _state;
		case GET_ROLE_ADMIN_INFO:
			_state.roles = [ ...action.value.roles ];
			_state.permissions = [ ...action.value.permissions ];
			return _state;
		default:
			return _state;
	}
};
